(function(angular) {
    'use strict';
    var app = angular.module('enervee.account');

    /*
    FavProductsService is responsible for making account favorite products page api calls and model level calculations
    */

    app.factory('AccountRebatesService', [
        'RebateApiConsumerService',
        'WITH_CREDENTIALS',
        function(
            RebateApiConsumerService,
            WITH_CREDENTIALS
        ) {
            var _pub = {},
                _rebates;


            /**
             * Fetches user's rewards (claims)
             * @param link
             * @returns {*}
             */
            _pub.fetchRebates = function() {
                return RebateApiConsumerService.get('/api/1.0/claim/claims/', WITH_CREDENTIALS).then(function(results) {
                    _rebates = results.data;
                });
            };


            /**
             * Gets users fetched rebates
             * @returns {*}
             */
            _pub.getRebates = function() {
                return _rebates;
            };


            /**
             * Gets user's rebates count
             * @returns {*}
             */
            _pub.getRebatesCount = function() {
                return _rebates.count;

            };

            return _pub;
        }
    ]);

})(angular);